import {memo} from 'react'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {
    StyledConversationMessagesSkeletonContainer,
    StyledMessageBubbleSkeleton,
    StyledMessageBubbleContent
} from './style.ts'

interface ConversationMessagesSkeletonProps {
    messageCount?: number
}

const ConversationMessagesSkeletonComponent = ({messageCount = 8}: ConversationMessagesSkeletonProps) => {
    return (
        <StyledConversationMessagesSkeletonContainer gap={2} direction="column-reverse" justify="flex-start" fullWidth>
            {Array.from({length: messageCount}).map((_, index) => {
                // Vary message lengths for more realistic look
                const isOwnMessage = index % 3 === 0
                const messageWidth = index % 4 === 0 ? '45%' : index % 3 === 0 ? '65%' : '55%'

                return (
                    <MessageBubbleSkeleton
                        key={index}
                        index={index}
                        isOwnMessage={isOwnMessage}
                        messageWidth={messageWidth}
                    />
                )
            })}
        </StyledConversationMessagesSkeletonContainer>
    )
}

interface MessageBubbleSkeletonProps {
    index: number
    isOwnMessage: boolean
    messageWidth: string
}

const MessageBubbleSkeleton = ({index, isOwnMessage, messageWidth}: MessageBubbleSkeletonProps) => {
    return (
        <Flexbox fullWidth justify={isOwnMessage ? 'flex-end' : 'flex-start'} style={{marginBottom: '8px'}}>
            <StyledMessageBubbleSkeleton $isOwnMessage={isOwnMessage} style={{maxWidth: messageWidth}}>
                <StyledMessageBubbleContent direction="column" gap={1}>
                    <Skeleton width="100%" height={14} />
                    {index % 5 !== 0 && <Skeleton width="80%" height={14} />}
                    {index % 7 === 0 && <Skeleton width="60%" height={14} />}

                    <Flexbox justify="flex-end" align="center" gap={1} style={{marginTop: '4px'}}>
                        <Skeleton width={30} height={10} />
                        {index % 8 === 0 && <Skeleton width={40} height={12} />}
                    </Flexbox>
                </StyledMessageBubbleContent>
            </StyledMessageBubbleSkeleton>
        </Flexbox>
    )
}

export const ConversationMessagesSkeleton = memo(ConversationMessagesSkeletonComponent)
